import Routes from "./Routes";
import { Toaster } from "@/components/ui/toaster";
import { TopNav } from "@/components/TopNav";
import { Footer } from "@/components/Footer";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SEOHead } from "@/components/SEOHead";
import { PWAManifest } from "@/components/PWAManifest";
import { ServiceWorkerUpdater } from "@/components/ServiceWorkerUpdater";
import { OnboardingWizard } from "@/components/onboarding/OnboardingWizard";
import { MobilePerformanceMonitor } from "@/components/MobilePerformanceMonitor";
import { AuthPromptProvider } from "@/components/auth/AuthPromptProvider";



// SEOAnalytics moved to Admin page
import { ProductionOptimizer } from '@/components/ProductionOptimizer';
import { SEOPerformanceMonitor } from '@/components/seo/SEOPerformanceMonitor';
// CoreWebVitalsMonitor moved to Admin page
import { CriticalResourcePreloader } from '@/components/seo/CriticalResourcePreloader';
import { useScrollToTop } from '@/hooks/useScrollToTop';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logger } from '@/utils/logger';

function App() {
  const location = useLocation();
  
  // Use custom scroll-to-top hook for better SPA behavior
  useScrollToTop();

  // Web Vitals observer lives in MobilePerformanceMonitor / ProductionOptimizer.
  // Duplicating it here registered LCP/FCP three times — removed.

  return (
    <ErrorBoundary>
      <MobilePerformanceMonitor enableReporting={import.meta.env.MODE === 'production'}>
        <AuthPromptProvider>
          <div className="min-h-screen flex flex-col">
            <CriticalResourcePreloader />
            <SEOHead />
            {/* SEOAnalytics moved to Admin page */}
            <ProductionOptimizer />
            
            
            <PWAManifest />
            <SEOPerformanceMonitor />
            {/* CoreWebVitalsMonitor moved to Admin page */}
            <TopNav />
            <div className="flex-grow pt-16 md:pt-20">
              <Routes />
            </div>
            <Footer />
            <Toaster />
            <ServiceWorkerUpdater />
            <OnboardingWizard />
          </div>
        </AuthPromptProvider>
      </MobilePerformanceMonitor>

    </ErrorBoundary>
  );
}

export default App;